<template>
  <div
    :class="`button ${size} ${disabled ? 'disabled' : ''} ${type}`"
    :disabled="disabled"
    @click="onClick"
    role="button">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import { DetailButtonType, DetailButtonSize } from '../types';

export default defineComponent({
  name: 'Button',
  props: {
    size: {
      type: String as PropType<DetailButtonSize>,
      default: DetailButtonSize.normal,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<DetailButtonType>,
      default: DetailButtonType.primary,
    },
  },
  setup(props, { emit }) {
    return {
      onClick() {
        emit('click');
      },
    };
  },
});
</script>

<style lang="less" scoped>
@rem: 200rem;
@import (reference) '~@wphk-ui/styles/fonts.less';

.button {
  height: 80 / @rem;
  min-width: 368 / @rem;
  color: white;
  background-color: #07c160;
  width: 368 / @rem;
  .font-34-regular;
  border-radius: 8 / @rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  &:active {
    opacity: 0.7;
  }
  &.small {
    height: 56 / @rem;
    width: 116 / @rem!important;
    min-width: 116 / @rem;
    .font-28-regular;
    border-radius: 6 / @rem;
  }
  &.disabled {
    // background-color: rgba(0, 0, 0, 0.04);
    // color: rgba(0, 0, 0, 0.3);
    opacity: 0.3;
  }
  &.ghost {
    background-color: #f2f2f2;
    color: #07c160;
  }
  &.outofperiod {
    background-color: #f2f2f2;
    color: #B3B3B3;
    opacity: 1!important;
  }
}
</style>
